import MxAutoCompleteField from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import { A_REALESTATE_TYPES } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { forwardRef } from "react";
import MxSelectConditionPropertyField, {
  MxSelectConditionPropertyFieldProps
} from "@rf-l1/form/selects/MxSelectConditionPropertyField";

type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";
export interface MxFormMxFormConditionPropertyPropertyProps
  extends Omit<MxSelectConditionPropertyFieldProps, omit> {}

const MxFormConditionProperty = forwardRef<
  HTMLInputElement,
  MxFormMxFormConditionPropertyPropertyProps
>((props, ref) => {
  const { onChange, onBlur, name, value, invalid, id, inputRef, testId } =
    useMxFieldControllerContext();
  return (
    <MxSelectConditionPropertyField
      {...props}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
});

export default MxFormConditionProperty;
